module.exports = __webpack_public_path__ + "static/media/webinar.ceba688a.png";